import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { p, px, py, pt, pb, pl, pr, pbs, pie, pbe, pis, pbl, pi } from '../../spacing';
export const paddings = () => css`
  ${_ref => {
  let {
    padding
  } = _ref;
  return map(padding, val => val !== undefined && css`
          ${p(val)};
        `);
}};

  ${(_ref2 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingHorizontal
  } = _ref2;
  return map(paddingHorizontal, val => val !== undefined && css`
          ${px(val)};
        `);
}};

  ${(_ref3 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingVertical
  } = _ref3;
  return map(paddingVertical, val => val !== undefined && css`
          ${py(val)};
        `);
}};

  ${(_ref4 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingTop
  } = _ref4;
  return map(paddingTop, val => val !== undefined && css`
          ${pt(val)};
        `);
}};

  ${(_ref5 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingBottom
  } = _ref5;
  return map(paddingBottom, val => val !== undefined && css`
          ${pb(val)};
        `);
}};

  ${(_ref6 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingLeft
  } = _ref6;
  return map(paddingLeft, val => val !== undefined && css`
          ${pl(val)};
        `);
}};

  ${(_ref7 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingRight
  } = _ref7;
  return map(paddingRight, val => val !== undefined && css`
          ${pr(val)};
        `);
}};

  ${(_ref8 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingBlockStart
  } = _ref8;
  return map(paddingBlockStart, val => val !== undefined && css`
          ${pbs(val)};
        `);
}};

  ${(_ref9 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingInlineEnd
  } = _ref9;
  return map(paddingInlineEnd, val => val !== undefined && css`
          ${pie(val)};
        `);
}};

  ${(_ref10 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingBlockEnd
  } = _ref10;
  return map(paddingBlockEnd, val => val !== undefined && css`
          ${pbe(val)};
        `);
}};

  ${(_ref11 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingInlineStart
  } = _ref11;
  return map(paddingInlineStart, val => val !== undefined && css`
          ${pis(val)};
        `);
}};

  ${(_ref12 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingBlock
  } = _ref12;
  return map(paddingBlock, val => val !== undefined && css`
          ${pbl(val)};
        `);
}};

  ${(_ref13 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    paddingInline
  } = _ref13;
  return map(paddingInline, val => val !== undefined && css`
          ${pi(val)};
        `);
}};
`;